// extracted by mini-css-extract-plugin
export var base = "_1a-0";
export var updateBanner = "_1a-1";